<template>
  <div class="modal" tabindex="-1" id="wheel__modal">
    <transition name="fadeOut" v-if="stepNumber == 1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" :class="{ 'modal-prize-bg': stepNumber === 2 }">
          <div class="modal-body position-relative p-0">
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 m-0 pt-4 btn-close-white "
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container position-relative p-0">
              <img src="@/assets/images/campaigns/mex-independence-2026/bg-top.png" alt="ruleta"
                class="w-100 position-absolute" />
              <div class="row justify-content-center">
                <img src="@/assets/images/campaigns/mex-independence-2026/lbl-01.png" alt="ruleta"
                  class="w-50 mb-4 mt-3 mt-lg-5">
                <p class="bowlby-one-sc-regular fs-4 lh-1 text-white text-center">SPIN THE FIESTA WHEEL <br> AND UNLOCK
                  A SPECIAL BONUS </p>
                <div id="wheel__interface" class="col-12 mt-lg-3">
                  <img :src="spinerImg" alt="" class="spinner">
                  <div class="roulette-container position-relative">
                    <img src="@/assets/images/campaigns/mex-independence-2026/wheel.png" alt="ruleta" class="wheel"
                      :style="{ transform: `rotate(${rotation}deg)` }" />
                    <div class="debug-cross" v-if="showDebug"></div>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center">
                  <div class="col-4 btn-spin rounded-pill text-center my-3" @click="spin"><span
                      class="spin-text">SPIN</span></div>
                </div>
                <div class="row align-items-center justify-content-center">
                  <div class="col-8  text-center">
                    <p class="terms text-start ps-3">Does not apply with other promotions. <br>
                      Valid with the purchase of a Vacation Package to Mexico. <br>
                      'Only with the purchase of a $599 package.</p>
                  </div>
                  <div class="col-4 text-center">
                    <img src="@/assets/images/campaigns/mex-independence-2026/logo.png" alt="ruleta" class="w-50 mb-3">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fadeOut" mode="out-in">
      <div class="modal-dialog modal-dialog-centered" v-if="stepNumber == 2" key="step2">
        <div class="modal-content modal-prize" :class="{ 'modal-prize-bg': stepNumber === 2 }">
          <div class="modal-body position-relative">
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 m-0 pt-4 btn-close-white"
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container">
              <div class="row justify-content-center mt-3">
                <div class="mt-4">
                  <div class="col-12 text-center">
                    <h2 class="bowlby-one-sc-regular text-white mb-lg-3">CONGRATULATIONS!</h2>
                    <p class="fs-4 text-white px-5 lh-1 fw-bold jost-regular pb-0">YOU UNLOCKED A SPECIAL
                      MEXICO GETAWAY BONUS:</p>
                  </div>
                </div>
                <div class="col-12 text-center">
                  <img :src="selectedPrize.imgUrl" alt="" class="prize-img py-3">
                </div>
                <div class="col-12">
                  <lotteryForm :prizeCode="selectedPrize.code" :prizeName="selectedPrize.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import { useWebsiteStore } from '@/store/website';
import lotteryForm from "@/components/TheLotteryForm.vue"
import Confetti from 'canvas-confetti'


export default {
  data() {
    return {
      prizes: [
        {
          name: "100USDGIFT",
          code: '#100USDGIFT',
          imgUrl: require("../assets/images/campaigns/mex-independence-2026/prizes/prize-01.png") // amazing week , free vegas trip
        },
        {
          name: "FREE VEGAS TRIP",
          code: '#FREEVEGAS',
          imgUrl: require("../assets/images/campaigns/mex-independence-2026/prizes/prize-02.png")//40 cert
        },
        {
          name: "50USDGIFT",
          code: '#50USDGIFT',
          imgUrl: require("../assets/images/campaigns/mex-independence-2026/prizes/prize-03.png") // amazing week , free vegas trip
        },
        {
          name: "75USDGIFT",
          code: '#75USDGIFT',
          imgUrl: require("../assets/images/campaigns/mex-independence-2026/prizes/prize-04.png") // amazing week , free vegas trip
        },
        {
          name: "FREECRUISE",
          code: '#FREECRUISE',
          imgUrl: require("../assets/images/campaigns/mex-independence-2026/prizes/prize-05.png") // amazing week , free vegas trip
        },

      ],
      spinerImg: require('@/assets/images/campaigns/mex-independence-2026/pointer.png').default,
      rotation: 0,
      showDebug: false,
      initialOffset: 0,
      isSpinning: false,
      selectedPrize: {
        name: "FREE VEGAS TRIP",
        code: '#FREEVEGAS',
        imgUrl: require("../assets/images/campaigns/2025-black-friday/prizes/prize-01.png")
      },
      stepNumber: 1,
      campaign: {
        name: "mex-independence",
        fromDate: new Date(2026, 8, 9, 0, 0, 0),      // Oct 20, 2025
        toDate: new Date(2026, 8, 17, 23, 59, 59),     // Nov 3, 2025
        image: "images/campaigns/banners/halloween-2025.jpg"
      },
    };
  },
  components:
  {
    lotteryForm
  },
  mounted() {
    const isTestCampaign = this.$route.query.campaign
    if (isTestCampaign === 'mex-independence' || this.isCampaign()) {
      this.showModal()
      this.initialOffset = 0; // Cambiado de anglePerPrize / 2 a 0
      this.rotation = 0; // Inicia en 0 grados, alineado con división
    }
  },
  computed: {
    // websiteStore() {
    //   return useWebsiteStore();
    // }
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#wheel__modal', { backdrop: false });
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    spin() {
      if (this.isSpinning) return;

      this.isSpinning = true;
      this.selectedPrize = null;

      const total = this.prizes.length;
      const anglePerPrize = 360 / total;
      const extraSpins = 5;
      const randomAngle = Math.floor(Math.random() * 360);
      const finalRotation = 360 * extraSpins + randomAngle;

      this.rotation += finalRotation;

      setTimeout(() => {
        this.isSpinning = false;

        const normalizedAngle = this.rotation % 360;
        const startOffset = 0; // segment boundary sits at the pointer (12 o'clock) on this wheel
        const adjustedAngle = (360 - normalizedAngle + startOffset) % 360;
        const prizeIndex = Math.floor(adjustedAngle / anglePerPrize);

        this.selectedPrize = this.prizes[prizeIndex];

        setTimeout(() => {
          this.stepNumber = 2;
          this.getConfetti();
        }, 500);
      }, 4000);
    },
    getConfetti() {
      Confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000,
        shapes: ['circle'],
        colors: ['#d5a432']
      })
    },
    isCampaign() {
      const now = new Date();
      //const now = new Date(2025, 11, 27); // Test
      const from = new Date(this.campaign.fromDate);
      const to = new Date(this.campaign.toDate);
      return from <= now && now <= to;
    }
  }
};
</script>

<style scoped>
.debug-cross {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.debug-cross::before,
.debug-cross::after {
  content: "";
  position: absolute;
  background: rgba(255, 0, 0, 0.4);
}

.debug-cross::before {
  /* línea vertical */
  left: 50%;
  top: 0;
  width: 2px;
  height: 100%;
}

.debug-cross::after {
  /* línea horizontal */
  top: 50%;
  left: 0;
  height: 2px;
  width: 100%;
}

.modal-content {
  background-image: url('../assets/images/campaigns/mex-independence-2026/bg.png');
  background-size: cover;
  background-position: center;
}

.btn-close {
  margin-top: 6px !important;
  background-color: transparent !important;
}

#wheel__interface {
  text-align: center;
  font-family: Arial, sans-serif;
}

.roulette-container {
  position: relative;
  width: 260px;
  height: 260px;
  margin: 0 auto;
}

.wheel {
  width: 100%;
  height: 100%;
  transition: transform 4s cubic-bezier(0.33, 1, 0.68, 1);
  transform-origin: center;
  border-radius: 50%;
  z-index: 0;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.spinner {
  position: absolute;
  margin-top: -.8rem;
  left: 46%;
  width: 8%;
  z-index: 1 !important;
}

.btn-spin {
  cursor: pointer;
  background: #d70200;
  /*background: linear-gradient(180deg, rgba(143, 220, 88, 1) 0%, rgba(49, 144, 97, 1) 100%);*/
  color: #fff;
  border-color: none !important;
  font-size: 25px;
  font-weight: 900;
  box-shadow: 183, 1, 23, 1px #b70117;
  -webkit-box-shadow: 0px 6px 0px 0px #b70117;
  -moz-box-shadow: 183, 1, 23, 1px #b70117;
  letter-spacing: 4px;
  width: 220px;
}

.spin-text {
  letter-spacing: 1px;
  text-shadow: 1px 1px 0 rgba(128, 128, 128, 0.2), -1px -1px 0 rgba(128, 128, 128, 0.2), 1px -1px 0 rgba(128, 128, 128, 0.2), -1px 1px 0 rgba(128, 128, 128, 0.2);
}

.terms {
  font-size: 10px;
  color: #fff;
  font-weight: 400;
}

#app>*:nth-child(3) {
  padding-top: 0rem;
}

.modal-prize-bg {
  background-image: url('../assets/images/campaigns/mex-independence-2026/bg.png') !important;
  background-size: cover;
  background-position: center;
}


.win {
  font-family: "Arial";
  font-weight: 800;
  transform: scaleY(1.3);
  letter-spacing: -1px;
  color: white;
  line-height: 20px;
  font-size: 30px;
}

.prize-img {
  width: 50%;
}

/*--------PRIZE MODAL--------*/
/* .modal-content.modal-prize {
  background-image: url(../assets/images/campaigns/2025-halloween/prize-bg.jpg);
  background-size: cover;
  background-position: center;
} */
/*------BREAKPOINTS------*/
@media (min-width: 500px) and (max-width: 768px) {
  .btn-spin {
    position: relative;
    margin-top: 40px !important;
  }

  .terms {
    margin-top: 55px !important;
    padding-top: 10px;
    font-size: .7rem !important;
  }

  .roulette-container {
    width: 280px !important;
    height: 280px !important;
  }

  .prize-img {
    width: 35%;
  }
}

@media(max-width: 768px) {
  .btn-spin {
    position: relative;
  }

  .terms {
    margin-top: 25px;
    padding-top: 10px;
    font-size: .6rem;
  }

  #wheel__interface {
    margin-top: 20px;
  }

  .roulette-container {
    width: 250px;
    height: 250px;
  }


}

@media (max-width: 360px) {
  .terms {
    font-size: .5rem;
  }
}

/*----------------------------- */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.bowlby-one-sc-regular {
  font-family: "Bowlby One SC", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-shadow: 1px 1px 2px rgb(0, 0, 0);
}

.bowlby-one-sc-regular {
  font-family: "Bowlby One SC", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.jost-regular {
  font-family: "Jost", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  text-shadow: 1px 1px 2px rgb(0, 54, 16);
}
</style>
